import { getItems } from "../../../api/items";

const PAGE_SIZE = 1000;

// Fetch raw paginado até esgotar (usado pelos dashboards que agregam client-side).
// reachedPageLimit = true significa que o universo foi truncado em maxPages × 1000 —
// o call site DEVE mostrar um aviso (nunca truncar em silêncio).
export const fetchAllItemPages = async (
    entity: string,
    fieldsQuery: string,
    filter: any,
    options?: { maxPages?: number; sort?: string }
): Promise<{ items: Array<any>; reachedPageLimit: boolean }> => {
    const maxPages = options?.maxPages ?? 8;
    const allItems: Array<any> = [];
    for (let page = 0; page < maxPages; page++) {
        const { items } = await getItems(entity, fieldsQuery, { filter, pageSize: PAGE_SIZE, page, sort: options?.sort ?? "id" });
        allItems.push(...items);
        if (items.length < PAGE_SIZE) {
            const completeResult = { items: allItems, reachedPageLimit: false };
            return completeResult;
        }
    }
    const truncatedResult = { items: allItems, reachedPageLimit: true };
    return truncatedResult;
};
